module.exports.versions = [
  '0.1.0',
  '0.2.0',
  '0.3.0',
  '0.4.0',
  '0.6.0',
  '0.7.0',
  '0.9.0',
  '0.10.0',
  '0.14.0',
  '0.15.0',
  '0.16.0',
  '0.17.0',
  '0.18.0',
  '0.19.0',
  '0.20.0',
  '0.21.0',
  '0.22.0',
  '0.23.0',
  '0.26.0',
  '0.27.0',
  '0.29.0',
  '0.33.0',
  '0.34.0',
  '0.37.0',
  '0.37.1',
  '0.38.0',
  '0.40.0',
  '0.41.0',
  '0.43.0',
  '0.44.0',
  '0.47.0',
  '0.51.0',
  '0.52.0',
  '0.54.0',
  '0.55.0',
  '0.55.1',
  '0.58.1',
  '0.59.3',
  '0.59.4'
];

module.exports.target = '0.59.4';



//////////////////
// WEBPACK FOOTER
// ./~/camshaft-reference/versions/index.js
// module id = 1488
// module chunks = 6